
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(41|772|869|943)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
